import { useCallback, useState } from 'react'
import type { Engagement, EngagementDTO } from 'types/engagements'
import { postWithToken } from './http'

interface UseCreateEngagementReturn {
  createEngagement: (engagementDTO: EngagementDTO) => Promise<Engagement>
  isLoading: boolean
  error: Error | null
  createdEngagement: Engagement | null
}

export function useCreateEngagement(token: string): UseCreateEngagementReturn {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const [createdEngagement, setCreatedEngagement] = useState<Engagement | null>(null)

  const createEngagement = useCallback(
    (engagementDTO: EngagementDTO): Promise<Engagement> => {
      setIsLoading(true)
      setError(null)
      setCreatedEngagement(null)

      return postWithToken('engagements', token, engagementDTO)
        .then((response) => {
          const newEngagement = response as Engagement
          setCreatedEngagement(newEngagement)
          return newEngagement
        })
        .catch((err) => {
          const error = err instanceof Error ? err : new Error('An error occurred')
          setError(error)
          throw error
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    [token]
  )

  return {
    createEngagement,
    isLoading,
    error,
    createdEngagement,
  }
}
